import axiosInstance from '../utils/axios';
import API_CONFIG from '../config/api.config';

const getTopSellingProducts = async (locationId, startDate, endDate) => {
  try {
    const params = {};
    if (locationId) {
      params.locationId = locationId;
    }
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get(
      `${API_CONFIG.ENDPOINTS.REPORTS}/top-selling-products`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching top selling products:', error);
    throw error;
  }
};

const getProductInvoiceDetails = async (productId, locationId, startDate, endDate) => {
  try {
    const params = {};
    if (locationId) {
      params.locationId = locationId;
    }
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get(
      `${API_CONFIG.ENDPOINTS.REPORTS}/top-selling-products/${productId}/invoices`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching product invoice details:', error);
    throw error;
  }
};

export default {
  getTopSellingProducts,
  getProductInvoiceDetails,
};

